import { SCPillInputProps, SCPillItem } from "@/components/sc-controls/form-controls/sc-control-interfaces/sc-pill-interfaces";
import {Group} from "@mantine/core";

export default function SCPill(inputProps: SCPillInputProps) {

    const {
        items = [],
        onChange,
        disabled = false,
        style,
        grow = false
    } = inputProps;

    const onClick = (item: SCPillItem) => {
        let itemsTemp = [...items];
        let idx = itemsTemp.findIndex((x: any) => x.label == item.label);
        if (idx > -1) {
            itemsTemp[idx].selected = !itemsTemp[idx].selected;
            onChange && onChange(itemsTemp);
        }
    }

    // `grow` fills the container width using a wrapping grid instead of Mantine's Group
    // grow (which sets flex-basis:0 and defeats flex-wrap, squashing every item onto one row).
    const groupStyle = grow
        ? { display: 'grid' as const, width: '100%', gridTemplateColumns: 'repeat(2, 1fr)', gap: 10 }
        : undefined;
    // Grid cells (unlike flex) don't stretch an item that has an explicit width, so drop the
    // caller's fixed width in favour of filling the cell.
    const itemStyle = grow ? { ...style, width: '100%' } : style;

    return (<>

        <Group gap={'xs'} style={groupStyle}>
            {items.map((item: any, key: any) => {
                return (
                    <div className={`pill ${item.selected ? "selected" : ""}`} key={key} onClick={() => onClick(item)}
                         style={itemStyle}
                    >
                        {item.label}
                    </div>
                );
            })}
        </Group>

        <style jsx>{`
            
            /*.pill-container {
                display: flex;
            }*/

            .pill {
                padding: 12px 16px;
                color: #5D5F60;
                border: 1px solid #F0F0F0;
                border-radius: 6px;
                background: #FFFFFF;
                cursor: pointer;
                -webkit-user-select: none; /* Safari */
                user-select: none; /* Standard syntax */
            }

            .pill:hover {
                background: #FAFAFA;
            }

            /*.pill + .pill {
                margin-left: 1rem;
            }*/

            .pill.selected {
                border: 1px solid #003ED0;
                color: #003ED0;
                background: rgb(230, 236, 250);
            }

        `}</style>
    </>);
};
